import BackIcon from './BackIcon'
import BurgerMenuIcon from './BurgerMenuIcon'
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from './CheckboxIcon'
import CopyIcon from './CopyIcon'
import DeleteIcon from './DeleteIcon'
import DownloadIcon from './DownloadIcon'
import EditIcon from './EditIcon'
import HideIcon from './HideIcon'
import KeyIcon from './KeyIcon'
import NetworkIcon from './NetworkIcon'
import PlusIcon from './PlusIcon'
import { RadioButtonCheckedIcon, RadioButtonUncheckedIcon } from './RadioButtonIcon'
import RefreshIcon from './RefreshIcon'
import RightBracketIcon from './RightBracketIcon'
import SearchIcon from './SearchIcon'
import { SmallCheckboxCheckedIcon, SmallCheckboxPartlyCheckedIcon, SmallCheckboxUncheckedIcon } from './SmallCheckboxIcon'
import UserIcon from './UserIcon'
import SettingsIcon from './SettingsIcon'
import ViewIcon from './ViewIcon'
//vej og park
import AppIcon from '../ui-icons/AppIcon';
import { BatteryLevelLowIcon, BatteryLevelMediumIcon, BatteryLevelFullIcon } from './BatteryLevelIcon';
import BorderValueActiveIcon from './BorderValueActiveIcon';
import BorderValueIcon from './BorderValueIcon';
import CloseIcon from './CloseIcon';
import ContactIcon from './ContactIcon';
import CounterIcon from './CounterIcon'
import Co2Icon from './Co2Icon';
import DistanceToTopIcon from './DistanceToTopIcon';
import DistanceVerticalIcon from './DistanceVerticalIcon';
import DropdownIcon from './DropdownIcon';
import FilterIcon from './FilterIcon';
import HumidityIcon from './HumidityIcon';
import LightIcon from './LightIcon'
import MapIcon from './MapIcon';
import { MapMarkerIcon, MapMarkerActiveIcon } from './MapMarkerIcon';
import MapMarkerColouredIcon from './MapMarkerColouredIcon';
import { MapMarkerAlarmIcon, MapMarkerAlarmActiveIcon } from './MapMarkerAlarmIcon';
import MapPinIcon from './MapPinIcon';
import MovementIcon from './MovementIcon'
import NoDataIcon from './NoDataIcon'
import PredictionIcon from './PredictionIcon';
import SiteIcon from './SiteIcon';
import SoundIcon from './SoundIcon'
import TemperatureIcon from './TemperatureIcon';
import ConWxLogo from './ConWxLogo';
import ConWxMetOceanLogo from './ConWxMetOceanLogo';

const UIIcons = {
    //ui icons
    BackIcon,
    BurgerMenuIcon,
    CheckboxCheckedIcon,
    CheckboxUncheckedIcon,
    SmallCheckboxCheckedIcon,
    SmallCheckboxPartlyCheckedIcon,
    SmallCheckboxUncheckedIcon,
    CopyIcon,
    DeleteIcon,
    DownloadIcon,
    EditIcon,
    HideIcon,
    KeyIcon,
    NetworkIcon,
    PlusIcon,
    RadioButtonCheckedIcon,
    RadioButtonUncheckedIcon,
    RefreshIcon,
    RightBracketIcon,
    SearchIcon,
    SettingsIcon,
    UserIcon,
    ViewIcon,
    //vej og park
    AppIcon,
    BatteryLevelLowIcon,
    BatteryLevelMediumIcon,
    BatteryLevelFullIcon,
    BorderValueActiveIcon,
    BorderValueIcon,
    CloseIcon,
    ContactIcon,
    CounterIcon,
    Co2Icon,
    DistanceToTopIcon,
    DistanceVerticalIcon,
    DropdownIcon,
    FilterIcon,
    HumidityIcon,
    LightIcon,
    MapIcon,
    MapMarkerAlarmActiveIcon,
    MapMarkerAlarmIcon,
    MapMarkerIcon,
    MapMarkerActiveIcon,
    MapMarkerColouredIcon,
    MapPinIcon,
    MovementIcon,
    NoDataIcon,
    PredictionIcon,
    SiteIcon,
    SoundIcon,
    TemperatureIcon,
    ConWxLogo,
    ConWxMetOceanLogo
}

export default UIIcons